export default __webpack_public_path__ + "static/media/paymentProof.ea7c485e.svg";